import {
  BasketColumn,
  BasketColumnKeys,
} from 'graphql-api/baskets-api-interfaces';

export function isManualDiscountColumn(column: BasketColumn) {
  return [
    BasketColumnKeys.ManualDiscount,
    BasketColumnKeys.SimulatedTotal,
  ].includes(column.key);
}
